import React from "react";
import { fmtMinutes } from "@/components/TaskShared";

const DOW = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

// Same capacity draw as Workload › Capacity: done = tracked (or estimate); open = estimate remaining, or tracked if overrun.
export function capacityDraw(t) {
  const est = t.time_estimate_minutes || 0;
  const trk = t.time_minutes || 0;
  if (t.is_completed) return trk > 0 ? trk : est;
  return est <= 0 ? 0 : (trk <= est ? est - trk : trk);
}

export function capacityByDay(tasks, user) {
  const cap = user?.capacity_days || {};
  const sched = user?.schedule_hours || null;
  const works = (iso) => { if (!sched) return true; const raw = sched[DOW[new Date(iso + "T00:00:00").getDay()]]; return (Array.isArray(raw) ? raw : raw ? [raw] : []).some((b) => b && b.start && b.end); };
  const m = {};
  (tasks || []).forEach((t) => {
    if (!t.due_date) return;
    const c = m[t.due_date] || (m[t.due_date] = { used: 0 });
    c.used += capacityDraw(t);
  });
  return {
    get: (iso) => ({ used: (m[iso] || {}).used || 0, cap: works(iso) ? Math.round((cap[DOW[new Date(iso + "T00:00:00").getDay()]] || 0) * 60) : 0 }),
  };
}

export const loadTone = (used, cap) => (cap <= 0 ? (used > 0 ? "over" : "off") : used > cap ? "over" : used >= cap * 0.85 ? "near" : "ok");
const TONE = { ok: "bg-[#1f9d55]", near: "bg-[#F59E0B]", over: "bg-[#e5484d]", off: "bg-[#c4c5cc]" };
const TEXT = { ok: "text-[#595D62]", near: "text-[#b7791f]", over: "text-[#c0392b]", off: "text-[#9FA1A4]" };

export function CapacityBar({ used, cap, testid, compact }) {
  const tone = loadTone(used, cap);
  const pct = cap > 0 ? Math.min(100, Math.round((used / cap) * 100)) : used > 0 ? 100 : 0;
  return (
    <div data-testid={testid} data-tone={tone} className={compact ? "mt-1 w-full" : "w-28"} title={`${fmtMinutes(used) || "0m"} of ${fmtMinutes(cap) || "0m"} capacity`}>
      <div className="h-1.5 rounded-full bg-[#EEEFEF] overflow-hidden"><div className={`h-full rounded-full transition-all ${TONE[tone]}`} style={{ width: `${pct}%` }} /></div>
      <p className={`mt-0.5 text-[9px] font-semibold leading-none font-mono-data ${TEXT[tone]}`}>{cap > 0 || used > 0 ? `${fmtMinutes(used) || "0m"} / ${fmtMinutes(cap) || "0m"}` : "Off"}</p>
    </div>
  );
}
